import { createAsyncThunk } from "@reduxjs/toolkit";
import axiosInstance from "../axiosInstance";

// Define an async thunk to fetch data from the API

// const user_id = localStorage.setItem("user_id", user_id);

export const fetchProfileData = createAsyncThunk(
  "viewprofile",
  async (id, { rejectWithValue }) => {
    try {

      if(id){

        const response = await axiosInstance.get(`/auth/provider/${id}`);
        return response.data;
      }
      else{
        return null;  
      }
      
    } catch (error) {
      // Handle errors appropriately
      return rejectWithValue(
        error.response ? error.response.data : "An error occurred"
      );
    }
  }
);
